import '../css/blog.css';

document.addEventListener('DOMContentLoaded', function() {
    // Function to toggle content visibility
    function toggleContent(header, content) {
        header.addEventListener('click', function() {
            // Toggle the hidden class on content
            content.classList.toggle('hidden');
            content.classList.toggle('flex');
        });
    }

    // Handle "Najbardziej popularne" section
    const popularHeader = document.querySelector('.popular p');
    const popularContent = document.querySelector('.popular-content');
    const popularIcon = document.querySelector('.popular svg');
    
    if (popularHeader && popularContent && popularIcon) {
        toggleContent(popularHeader, popularContent, popularIcon);
    }
    
    // Handle "Kategorie" section
    const categoriesHeader = document.querySelector('.categories p');
    const categoriesContent = document.querySelector('.categories-content');
    const categoriesIcon = document.querySelector('.categories svg');
    
    if (categoriesHeader && categoriesContent && categoriesIcon) {
        toggleContent(categoriesHeader, categoriesContent, categoriesIcon);
    }
});